import { render, staticRenderFns } from "./DevelopmentGuidance.vue?vue&type=template&id=186990a4&scoped=true&"
import script from "./DevelopmentGuidance.vue?vue&type=script&lang=js&"
export * from "./DevelopmentGuidance.vue?vue&type=script&lang=js&"
import style0 from "./DevelopmentGuidance.vue?vue&type=style&index=0&id=186990a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186990a4",
  null
  
)

export default component.exports